import theme from '../../base';

const storybook = {
  tableBg: theme.colors.neutrals.gray200,
  tableColorText: theme.colors.neutrals.gray900,
  tableColorTextReversed: theme.colors.neutrals.gray200,
  descriptionValueColor: theme.colors.neutrals.gray700,
  boxColor: theme.colors.yellows.yellow400,
  boxForegroundColor: theme.colors.neutrals.gray700,
  boxBorderColor: theme.colors.primary.primary700,
};

export default storybook;
